module.exports = __webpack_public_path__ + "static/media/4.2a12cb28.jpg";